import { FileSearchOutlined } from '@ant-design/icons';
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import Input from '../../../../../../components/input/Input';
import SearchCategoryUrlModal from './SearchCategoryUrlModal/SearchCategoryUrlModal';
import { generateUserWebCategoryPageUrl } from '../../../../../../lib/utils/categoryUtils';
import { UrlInputStyle } from './style';

interface UrlInputProps {
  value?: string;
  canCategorySearch: boolean;
  onChange?: (value: string) => void;
}

const UrlInput = forwardRef((props: UrlInputProps, ref) => {
  const { value, canCategorySearch, onChange } = props;
  const [isSearchCategoryModalOpen, setIsSearchCategoryModalOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    value,
    onChange,
  }));

  const handleOk = (mainCategoryId: number, subCategoryIdList?: number[]) => {
    const url = generateUserWebCategoryPageUrl(mainCategoryId, subCategoryIdList);
    onChange && onChange(url);
    setIsSearchCategoryModalOpen(false);
  };

  return (
    <UrlInputStyle>
      <Input value={value} onChange={(value: string) => onChange && onChange(value)} />
      {canCategorySearch && (
        <div className="product-category-search">
          <span>유저 웹 상품 카테고리 페이지 URL 설정</span>
          <FileSearchOutlined
            className="product-category-search-btn"
            onClick={() => setIsSearchCategoryModalOpen(true)}
          />
        </div>
      )}
      {isSearchCategoryModalOpen && (
        <SearchCategoryUrlModal onOk={handleOk} onClose={() => setIsSearchCategoryModalOpen(false)} />
      )}
    </UrlInputStyle>
  );
});
UrlInput.displayName = 'UrlInput';

export default UrlInput;
